import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import theme from '../../../theme';

const Flex = styled.div`
  display: flex;
  ${(props) => css`
    justify-content: ${props.justifyContent};
    align-content: ${props.alignContent};
    align-items: ${props.alignItems};
    flex-direction: ${props.flexDirection};
    justify-self: ${props.justifySelf};
    align-self: ${props.alignSelf};
    flex-grow: ${props.flexGrow};
    flex-shrink: ${props.flexShrink};
    flex-basis: ${props.flexBasis};
    flex-wrap: ${props.flexWrap};
    flex: ${props.flex};
    ${props.pullRight && css`
      margin-left: auto;
      flex-grow: 0;
    `};
  `}
  
  @media (min-width: ${theme.breakpoints.desktopLarge}) {
    ${(props) => props.pullRightDesktop && css`
      margin-left: auto;
      flex-grow: 0;
    `};
  }
`;

Flex.propTypes = {
  justifyContent: PropTypes.string,
  alignContent: PropTypes.string,
  alignItems: PropTypes.string,
  flexDirection: PropTypes.string,
  justifySelf: PropTypes.string,
  alignSelf: PropTypes.string,
  flexWrap: PropTypes.string,
  pullRight: PropTypes.bool,
  pullRightDesktop: PropTypes.bool,
  flexGrow: PropTypes.number,
  flexShrink: PropTypes.number,
  flexBasis: PropTypes.number,
  flex: PropTypes.string,
};
Flex.defaultProps = {
  flexGrow: 1,
  pullRight: false,
  pullRightDesktop: false,
};

export default Flex;
